import { useTranslation } from "react-i18next";
import { useGetUsersQuery } from "features/core/users/usersApiSlice";
import { useState } from "react";
import Modal from "components/commons/Modal";
import DateAndTimeRangePicker from "components/widget/DateAndTimeRangePicker";
import { useCreateOvertimeMutation } from "../api/overtimeApiSlice";
import SuccessMessage from "components/commons/SuccessMessage";



export default function OvertimeRequestModal() {


    const [t, i18n] = useTranslation(["global", "absenceReport"])

    const {
        data: users,
        isFetching,
        isSuccess,
        isError,
        error,
        refetch,
    } = useGetUsersQuery()

    const [
        sendRequest, {
            isLoading: sendingIsLoading,
            isSuccess: sendingResult }
    ] = useCreateOvertimeMutation()

    let content

    let errors = []
    const [workerGuid, setWorkerGuid] = useState();
    const [dateRange, setDateRange] = useState([null, null]);
    const [notes, setNotes] = useState("");

    if (!dateRange[1]) {
        errors.push("Invalid date range")
    }

    if (!workerGuid) {
        errors.push("Invalid date range")
    }

    function handleRequestSending() {
        const [startDate, endDate] = dateRange

        const startEpoch = (new Date(startDate).getTime()) / 1000
        const endEpoch = (new Date(endDate).getTime()) / 1000

        console.log("Received:" + "\n Start: " + startDate + "\n End: " + endDate)
        sendRequest({ userGuid: workerGuid, startDate: startEpoch, endDate: endEpoch, note: notes })

    }

    content =

        <>  {
            sendingResult == true &&
            <SuccessMessage message={ t("absenceReport:helper.send_success")}/>
        }

            <Modal
                title={ t("absenceReport:menu.new_overtime_request")}
                buttonIcon={<i className="fa-solid fa-circle-plus"></i>}
                buttonLabel= { t("absenceReport:menu.new_overtime_request")}
                locked={errors.length > 0}
                isConfirm = {true}
                onConfirm={handleRequestSending}
                body={
                    <>
                        <div className="row mb-4">
                            {
                                isSuccess &&
                                <div className="col-8">
                                    <select className="form-select" aria-label="Default select example" value={workerGuid || t("absenceReport:helper.select_worker")} onChange={(e) => setWorkerGuid(e.target.value)}>
                                        {/* <option selected value=""> { t("absenceReport:helper.select_worker")}</option> */}
                                        {
                                            users.map(user => (<option key={user.guid} value={user.guid}>{user.displayName}</option>))
                                        }
                                    </select>
                                </div>
                            }
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <label>{t("helper.select_date_time")} <span className="text-muted small">*</span></label><br />
                                <DateAndTimeRangePicker
                                    dateRange={dateRange}
                                    onDateTimePicked={setDateRange} /><br />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="notes">{t("property.notes")}:</label><br />
                            <textarea id="notes" name="notes" rows="4" cols="50" value={notes} onChange={(e) => setNotes(e.target.value)} />
                        </div>
                    </>
                }
            />

        </>


    return content

}